import { isEmpty, isNil, cloneDeep } from 'lodash';
import { performanceChart } from '@/mixins/performance/charts';
import WPlotLineChart from '@/views/performance/node/analysis/components/PlotLineChart';
import WPlotAreaChart from '@/views/performance/node/analysis/components/PlotAreaChart';

export default {
  name: 'WPerformanceAnalysisChart',
  components: {
    WPlotLineChart,
    WPlotAreaChart,
  },
  mixins: [performanceChart],
  props: {
    chartData: {
      type: Object,
    },
    visible: {
      type: Boolean,
    },
  },
  data() {
    return {
      mainChart: {},
      subCharts: [],
      existSubCharts: false,
      showSubCharts: false,
    };
  },
  watch: {
    chartData: {
      immediate: true,
      handler(value) {
        this.showSubCharts = false;
        this.addButtonIconName = 'triangle add';
        if (!isEmpty(value)) {
          this.mainChart = cloneDeep(value.mainChart);
          if (isEmpty(value.subCharts)) {
            this.existSubCharts = false;
            this.subCharts = [];
          } else {
            this.existSubCharts = true;
            this.subCharts = value.subCharts;
          }
        } else {
          this.mainChart = {};
          this.subCharts = [];
        }
      },
    },
  },
  methods: {
    isEmpty,
    /**
     * Main Chart의 +, x 버튼 클릭 시 sub Chart가 보여지거나 숨겨진다.
     * @return {[type]} [description]
     * @author jda
     */
    onShowSubChartButtonClick() {
      if (!isNil(this.existSubCharts) && !this.existSubCharts) {
        return;
      }
      this.showSubCharts = !this.showSubCharts;

      if (this.showSubCharts) {
        this.addButtonIconName = 'triangle subtract';
        this.subChartButtonClass = ['btn-expand', 'expand-select'];
        // this.subChartButtonClass = ['btn-expand', 'expand-select'];
        // TODO: Fontawesome5 SVG는 직접 svg요소의 data-icon 변경. 더 좋은 방법이 있으면 수정 필요
        // this.$el.querySelector('svg[data-icon]').setAttribute('data-icon', 'minus');
      } else {
        this.addButtonIconName = 'triangle add';
        this.subChartButtonClass = ['btn-expand'];
        // this.subChartButtonClass = ['btn-expand'];
        // this.$el.querySelector('svg[data-icon]').setAttribute('data-icon', 'plus');
      }

      this.$emit('show-sub-chart-button-click', this.chartData.id, this.showSubCharts);
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/performance/node/analysis/components/PerformanceAnalysisChartView/mixins/performance-analysis-chart.js